import { render, staticRenderFns } from "./AssociaDiariPresidiListComponent.vue?vue&type=template&id=50e6a68b"
import script from "./AssociaDiariPresidiListComponent.vue?vue&type=script&lang=js"
export * from "./AssociaDiariPresidiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports